import SlideIn from "./slide-in"

export default SlideIn
